// Local-calendar date helpers.
//
// Every "date" in this app is a plain YYYY-MM-DD calendar day — never a moment in time.
// If we do `new Date(iso).toISOString().slice(0,10)` in IST we drift back one day because
// toISOString() converts to UTC. So we do the conversion strictly in local time.

/** Format a JS Date as YYYY-MM-DD in the browser's LOCAL timezone. */
export function dateToLocalISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Parse YYYY-MM-DD -> Date at local midnight (never UTC). */
export function localDateFromISO(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

/** Add days to a YYYY-MM-DD string. Returns a new YYYY-MM-DD (still local). */
export function addDays(iso, n) {
  const d = localDateFromISO(iso);
  d.setDate(d.getDate() + n);
  return dateToLocalISO(d);
}

/** Enumerate all YYYY-MM-DD strings between fromISO and toISO (inclusive). */
export function enumerateDays(fromISO, toISO) {
  const out = [];
  let cur = fromISO;
  while (cur <= toISO) {
    out.push(cur);
    cur = addDays(cur, 1);
  }
  return out;
}

/** Today as YYYY-MM-DD in local tz. */
export function todayLocalISO() { return dateToLocalISO(new Date()); }

/** Current month as YYYY-MM in local tz (never UTC). */
export function monthLocalISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/**
 * Presets for date-range pickers used on Client Dashboard and /client/reports.
 * All results are pure YYYY-MM-DD strings — safe to pass straight to the API.
 */
export function datePresets() {
  const today = todayLocalISO();
  const now = new Date();
  const monthStart = dateToLocalISO(new Date(now.getFullYear(), now.getMonth(), 1));
  const lastMonthStart = dateToLocalISO(new Date(now.getFullYear(), now.getMonth() - 1, 1));
  const lastMonthEnd = dateToLocalISO(new Date(now.getFullYear(), now.getMonth(), 0));
  return {
    today:     { from: today, to: today },
    last7:     { from: addDays(today, -6), to: today },
    thisMonth: { from: monthStart, to: today },
    lastMonth: { from: lastMonthStart, to: lastMonthEnd },
  };
}
